import Vue from 'vue';
import Router from 'vue-router';
import routes from './router';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes
});
router.beforeEach((to, from, next) => {
  const buefyModal = document.getElementsByClassName("modal is-active");
  if (buefyModal && buefyModal.length > 0) {
    let elems = [];
    for (var modal of buefyModal) {
      elems.push(modal);
    }
    for (var elem of elems) {
      elem.remove();
    }    
  }
  next();
});
export default router;
